// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/login': [1, 2, 3, 4, 5],
  '/users': [5],
  '/organizations': [2, 3, 4, 5],
  '/programs': [3, 4, 5],
  '/dashboard': [4, 5],
  '/configuration': [5],
}
const FEATURE_PERMISSIONS = {
  organization_programs: [5],
  organization_config: [5],
  organization_removal: [5],
  organization_search: [5],
  organization_groupcode: [5],
  organization_storage: [5],
  organization_links: [5],
  member_removal: [2, 3, 4, 5],
  configuration: [5],
  dashboard_sims: [5],
}
export default {
  token: (state) => state.token,
  profile: (state) => state.profile,
  user: (state) => state.user,
  users: (state) => state.users,
  foundUsers: (state) => state.foundUsers,
  roles: (state) => state.roles,
  pager: (state) => state.pager,
  isChecked: (state) => state.isChecked,
  isAllowed: (state) => {
    return (page = '') => {
      if (!PAGE_PERMISSIONS[page]) {
        return true
      }
      if (state.profile.roles && state.profile.roles.length) {
        return state.profile.roles.some((r) =>
          PAGE_PERMISSIONS[page].includes(r.role_id)
        )
      }
      return PAGE_PERMISSIONS[page].includes('guest')
    }
  },
  isFeatureAllowed: (state) => {
    return (feature = '') => {
      // console.log('Checking Feature', feature)
      if (!FEATURE_PERMISSIONS[feature]) {
        return true
      }
      if (state.profile) {
        if (state.profile.roles && state.profile.roles.length) {
          return state.profile.roles.some((r) =>
            FEATURE_PERMISSIONS[feature].includes(r.role_id)
          )
        }
      }
      return FEATURE_PERMISSIONS[feature].includes('guest')
    }
  },
  note: (state) => state.note,
  notes: (state) => state.notes,
}
